module.exports = __webpack_public_path__ + "img/login-metalco.52b77e65.jpg";